export default __webpack_public_path__ + "static/media/receipts.3266ae6b.svg";